<template>
    <b-container>
        <b-row>
            <b-col class="text-primary px-0">
                <b-list-group>
                    <event-list-item v-for="(e, i) in events.past_events" :key="`past_${i}`" :event="e"></event-list-item>
                    <event-list-item v-for="(e, i) in events.future_events" :key="`future_${i}`" :event="e"></event-list-item>
                </b-list-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-btn :to="{name: 'termine'}" variant="link border" class="btn-block mt-3 d-flex align-items-center justify-content-between"><font-awesome-icon :icon="['far', 'arrow-left']" /><strong>Zurück</strong><font-awesome-icon :icon="['far', 'arrow-left']" style="opacity: 0" /></b-btn>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
    name: 'event-list-cmp',
    components: {
        EventListItem: () => import(/*webpackChunkName: "event-list-item" */ "@/components/EventListItem")
    },
    props: {
    },
    mounted() {
        this.init();
    },
    computed: {
        ...mapGetters('events', ['fetching', 'events'])
    },
    methods: {
        ...mapActions('events', ['fetchEvents']),
        init() {
            this.fetchEvents({past_events_only: true});
            this.addEventListener();
        },
        addEventListener() {
            // Event.$emit('saveApplicationSuccess', event);
            window.LC_Event.$on('saveApplicationSuccess', () => {
                this.fetchEvents({past_events_only: true});
            })
        }
    }
}
</script>

<style>

</style>